import { render, staticRenderFns } from "./bulletinBoard.vue?vue&type=template&id=9e1bea22&"
import script from "./bulletinBoard.vue?vue&type=script&lang=ts&"
export * from "./bulletinBoard.vue?vue&type=script&lang=ts&"
import style0 from "./bulletinBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports